document.addEventListener("DOMContentLoaded", () => {
  /* Open - Minicart Popup */
  /* -------------------------------------------------------------------------------------- */
  $("[js-open-minicart]").on("click", function (event) {
    event.preventDefault();
    /* Act on the event */
    if (typeof window.tidioChatApi !== "undefined") {
      window.tidioChatApi.hide();
    }
    addMiniCart();
  });
  /* Close - Minicart Popup */
  /* -------------------------------------------------------------------------------------- */
  $("[js-close-minicart]").on("click", function (event) {
    event.preventDefault();
    /* Act on the event */
    if (typeof window.tidioChatApi !== "undefined") {
      window.tidioChatApi.show();
    }
    $(".c-cart-pop-mini").removeClass("active");
    $(".c-cart-popup-notification").removeClass("active");
  });
  /* Add note to cart - Minicart Popup */
  /* -------------------------------------------------------------------------------------- */
  $("[js-minicart-popup]").on(
    "click",
    ".js-cart-min-add-note",
    function (event) {
      event.preventDefault();
      event.stopPropagation();
      var note = $(".js-cart-add-note").val();
      updateNoteMiniCart(note);
    }
  );
  /* Remove to cart - Minicart Popup */
  /* -------------------------------------------------------------------------------------- */
  $("[js-minicart-popup]").on(
    "click",
    ".js-cart-min-remove",
    async function (event) {
      event.preventDefault();
      event.stopPropagation();
      var el = $(this),
        line_item = parseFloat(el.attr("data-line-id")),
        product_id = parseFloat(
          el.closest(".js-cart-min-item").attr("data-product-id")
        ),
        promoProducts = el
          .closest(".js-cart-min-item")
          .attr("data-product-promo");
      actualizar = true;
      updateMiniCart(
        0,
        line_item,
        product_id,
        promoProducts,
        actualizar,
        event
      );
    }
  );
  /* Quantity Product - Minicart Popup */
  /* -------------------------------------------------------------------------------------- */
  $("[js-minicart-popup]").on("click", "[name=minus]", function (event) {
    event.preventDefault();
    /* Act on the event */
    var spinner = $(this),
      input = spinner
        .closest(".js-add-minicart-quantity")
        .find('input[type="number"]'),
      min = input.attr("min"),
      max = input.attr("max"),
      oldValue = parseFloat(input.val()),
      line_item = parseFloat(
        spinner.closest(".js-cart-min-item").attr("data-line-id")
      ),
      product_id = parseFloat(
        spinner.closest(".js-cart-min-item").attr("data-product-id")
      ),
      promoProducts = spinner
        .closest(".js-cart-min-item")
        .attr("data-product-promo"),
      actualizar = true;
    if (oldValue <= min) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue - 1;
    }
    input.val(newVal);
    input.trigger("change");
    updateMiniCart(
      newVal,
      line_item,
      product_id,
      promoProducts,
      actualizar,
      event
    );
  });

  $("[js-minicart-popup]").on("click", "[name=plus]", function (event) {
    event.preventDefault();
    /* Act on the event */
    var spinner = $(this),
      input = spinner
        .closest(".js-add-minicart-quantity")
        .find('input[type="number"]'),
      min = input.attr("min"),
      max = input.attr("max"),
      oldValue = parseFloat(input.val()),
      line_item = parseFloat(
        spinner.closest(".js-cart-min-item").attr("data-line-id")
      ),
      product_id = parseFloat(
        spinner.closest(".js-cart-min-item").attr("data-product-id")
      ),
      promoProducts = spinner
        .closest(".js-cart-min-item")
        .attr("data-product-promo"),
      actualizar = true;
    if (oldValue >= max) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue + 1;
    }
    input.val(newVal);
    input.trigger("change");
    updateMiniCart(
      newVal,
      line_item,
      product_id,
      promoProducts,
      actualizar,
      event
    );
  });

  $("[js-minicart-popup]").on(
    "keyup",
    ".js-quantity-input",
    debounce(function () {
      var input = $(this),
        inputValue = parseFloat(input.val()),
        line_item = input.attr("data-index"),
        product_id = parseFloat(
          input.closest(".js-cart-min-item").attr("data-product-id")
        ),
        promoProducts = input
          .closest(".js-cart-min-item")
          .attr("data-product-promo"),
        actualizar = true;
      updateMiniCart(
        inputValue,
        line_item,
        product_id,
        promoProducts,
        actualizar,
        event
      );
    }, 500)
  );
  /* Show note - Minicart Popup */
  /* -------------------------------------------------------------------------------------- */
  $("[js-minicart-popup]").on(
    "click",
    ".js-accordion-item-popup",
    function (event) {
      /* Act on the event */
      var el = $(this);
      el.toggleClass("show-body");
    }
  );
});
